import { Visit } from '@dreryk/egabinet-visit-frontend-api';

import { LoaderSpinner } from '@dreryk/react-components';

import { VisitDocumentContextProvider } from '../../../common/visitDocument/VisitDocumentContext';

import { useMedicalLeaveForGuardianDraft, useMedicalLeaveForGuardianDraftQuery } from './guardianMedicalLeave.hooks';
import { GuardianMedicalLeaveForm } from './GuardianMedicalLeaveForm';

type GuardianMedicalLeaveTabProps = {
   readonly visit: Visit;
};

export const GuardianMedicalLeaveTab = (props: GuardianMedicalLeaveTabProps): JSX.Element => {
   const { visit } = props;
   const { data: medicalLeave, loading: medicalLeaveLoading } = useMedicalLeaveForGuardianDraftQuery(visit.id);
   const guardianMedicalLeaveDraft = useMedicalLeaveForGuardianDraft(medicalLeave);

   if (medicalLeaveLoading) {
      return <LoaderSpinner />;
   }

   return (
      <VisitDocumentContextProvider
         externalId={guardianMedicalLeaveDraft?.externalId}
         forGuardian
         visitId={props.visit.id}
      >
         <GuardianMedicalLeaveForm visit={visit} draft={guardianMedicalLeaveDraft} />
      </VisitDocumentContextProvider>
   );
};
